module.exports = __webpack_public_path__ + "static/media/img_device.5e6d09d2.png";